import { computed } from "vue";
import { useStore } from "vuex";

import { CommunicationType } from "@/enums/communicationLogs";

import type { DynamicFieldOption, DynamicFieldOptions } from "@/models/options";

export function useEmailDynamicFields() {
  const { getters } = useStore();

  const emailDynamicFields = computed<DynamicFieldOption[]>(() => {
    const dynamicFields: DynamicFieldOptions | null =
      getters["options/dynamicFields"];
    if (!dynamicFields?.fields) {
      return [];
    }
    return dynamicFields.fields.filter(
      (field) =>
        field.tag.includes("email") &&
        (field.allowed_templates.length === 0 ||
          field.allowed_templates.includes(CommunicationType.email))
    );
  });

  return { emailDynamicFields };
}
